import { CommonModule } from '@angular/common';
import {
  HTTP_INTERCEPTORS,
  HttpClient,
  HttpClientModule,
} from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ServiceWorkerModule, SwUpdate, VersionEvent } from '@angular/service-worker';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { JwtInterceptor } from './interceptors/jwt.interceptor';
import { PoliciesPoliticsComponent } from './pages/policies-politics/policies-politics.component';
import { SharedModule } from './shared/shared.module';

import { ConfirmationService } from 'primeng/api';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ServiceWorkerUpdateService } from './services/service-worker-update.service';

export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient);
}

@NgModule({
  declarations: [AppComponent, PoliciesPoliticsComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    SharedModule,
    AppRoutingModule,
    CommonModule,
    HttpClientModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
      registrationStrategy: 'registerImmediately'
    }),
    ConfirmDialogModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),


    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production || (environment as any).testing,
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000'
    })
  ],

  providers: [
    ConfirmationService,

    {
      provide: HTTP_INTERCEPTORS,
      useClass: JwtInterceptor,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor(swUpdate: SwUpdate, swUpdateService: ServiceWorkerUpdateService) {

    if (swUpdate.isEnabled) {
      swUpdate.versionUpdates.subscribe(async (event: VersionEvent) => {

        if ((event as any).type !== 'VERSION_READY') {
          return;
        }

        // Notificar al servicio que hay actualización disponible
        swUpdateService.setUpdateAvailable(true);
      });

      swUpdate.checkForUpdate();

      setInterval(() => {
        swUpdate.checkForUpdate();
      }, 5 * 60 * 1000);
    } else {
    }
  }
}
